import { useForm } from 'react-hook-form';
import { SignupData } from '../types';

type Props = {
  onSubmit: (data: SignupData) => void
}

export const SignupForm = ({ onSubmit }: Props) => {
  const { register, handleSubmit, formState: { isSubmitting } } = useForm<SignupData>();

  return (
    <form
      className='flex flex-col w-full p-4'
      onSubmit={handleSubmit(onSubmit)}
    >
      <label>Email:</label>
      <input
        {...register('email', { required: true })}
        autoComplete='email'
        autoFocus
        className='mt-1 mb-4 mx-4 rounded-sm p-2 text-neutral-700'
      />

      <label>Password:</label>
      <input
        {...register('password1', { required: true })}
        autoComplete='new-password'
        className='mt-1 mb-4 mx-4 rounded-sm p-2 text-neutral-700'
        type='password'
      />

      <label>Password again:</label>
      <input
        {...register('password2', { required: true })}
        autoComplete='new-password'
        className='mt-1 mb-4 mx-4 rounded-sm p-2 text-neutral-700'
        type='password'
      />
      <input
        className='border rounded-sm p-2 px-4 self-center hover:bg-white hover:text-jw-blue cursor-pointer'
        disabled={isSubmitting}
        type='submit'
        value='Sign up'
      />
    </form>
  );
};
